<template>
  <div>
    <validation-observer ref="form">
      <b-card border-variant="primary">
        <b-card-header>
          <b-card-title>
            <feather-icon icon="FileIcon" size="20" class="mr-1" />
            Documentos
          </b-card-title>
        </b-card-header>

        <!-- Estado de lo obligatorio, visible siempre: antes solo se avisaba
             al intentar avanzar, con un toast que desaparecia. -->
        <b-alert :variant="hasOrder ? 'success' : 'warning'" show class="mb-2 p-1">
          <feather-icon :icon="hasOrder ? 'CheckCircleIcon' : 'AlertCircleIcon'" size="18" class="mr-50" />
          <span v-if="hasOrder">
            Ya cargaste {{ conteoOrdenes === 1 ? 'tu fórmula médica' : conteoOrdenes + ' fórmulas médicas' }}.
            Puedes continuar.
          </span>
          <span v-else>Para continuar necesitas cargar al menos una fórmula médica.</span>
        </b-alert>

        <b-row class="mt-1 form-row">
          <b-col sm="12" class="mb-2">
            <label class="d-block font-weight-bold mb-50">
              Fórmula médica <span class="text-danger">*</span>
            </label>
            <b-form-file v-model="fileForm.file" :accept="'image/*,.pdf'" :disabled="subiendo.order"
              :placeholder="subiendo.order ? 'Subiendo...' : (hasOrder ? 'Agregar otra fórmula médica' : 'Selecciona o arrastra tu fórmula médica')"
              :drop-placeholder="hasOrder ? 'Agregar otra fórmula médica' : 'Selecciona o arrastra tu fórmula médica'"
              browseText="Buscar" @change="fileSave(1)"/>

            <div v-if="subiendo.order" class="mt-50 text-primary">
              <b-spinner small class="mr-50" />
              <small>Subiendo el archivo, no cierres esta ventana...</small>
            </div>
            <small v-else class="text-muted d-block mt-50">
              Es la orden que te entregó el médico. Puedes agregar más de una si
              tu tratamiento lo requiere. Imagen o PDF, hasta 20 MB.
            </small>
          </b-col>

          <b-col sm="12">
            <label class="d-block font-weight-bold mb-50">
              Autorización <span class="text-muted font-weight-normal">(opcional)</span>
            </label>
            <b-form-file v-model="fileForm.fileLicense" :accept="'image/*,.pdf'" :disabled="subiendo.license"
              :placeholder="subiendo.license ? 'Subiendo...' : (hasLicense ? 'Agregar otra autorización' : 'Selecciona o arrastra tu autorización')"
              :drop-placeholder="hasLicense ? 'Agregar otra autorización' : 'Selecciona o arrastra tu autorización'"
              browseText="Buscar" @change="fileSave(2)" />

            <div v-if="subiendo.license" class="mt-50 text-primary">
              <b-spinner small class="mr-50" />
              <small>Subiendo el archivo, no cierres esta ventana...</small>
            </div>
            <small v-else class="text-muted d-block mt-50">
              Solo la necesitas si tus medicamentos son NO PBS (antes NO POS) o
              de alto costo. Si no es tu caso, puedes continuar sin ella.
            </small>
          </b-col>

          <b-col sm="12">
            <!-- Estado vacio: una tabla en blanco no comunica nada. -->
            <div v-if="!medicalAuthorizations.length"
                 class="text-center text-muted border rounded mt-2 py-3">
              <feather-icon icon="FileTextIcon" size="28" class="mb-50 d-block mx-auto" />
              <small>Todavía no has cargado documentos.</small>
            </div>

            <!-- Lista (no tabla) para que en el celular el boton de quitar
                 SIEMPRE se vea: en la tabla, la columna de acciones quedaba
                 fuera de pantalla a la derecha y el iPhone no mostraba la
                 papelera. Aqui cada archivo es una fila flexible con la X
                 visible al lado. -->
            <div v-else class="mt-1">
              <div v-for="item in medicalAuthorizations" :key="item.id"
                   class="d-flex align-items-center border rounded p-1 mb-1">
                <!-- Miniatura: el usuario confirma que subio la foto correcta. -->
                <b-img v-if="esImagen(item.name)" :src="urlArchivo(item)" rounded
                       style="width: 42px; height: 42px; object-fit: cover;" alt="" @error="ocultar" />
                <feather-icon v-else icon="FileTextIcon" size="24" class="text-muted" />

                <div class="flex-grow-1 mx-1" style="min-width: 0;">
                  <b-badge :variant="item.type === 'order' ? 'light-primary' : 'light-secondary'">
                    {{ item.type === 'order' ? 'Fórmula médica' : 'Autorización' }}
                  </b-badge>
                  <div class="text-break small mt-25">{{ item.name }}</div>
                </div>

                <b-button variant="flat-danger" class="btn-icon flex-shrink-0"
                          :disabled="borrando === item.id" @click="fileDelete(item)"
                          title="Quitar documento">
                  <b-spinner v-if="borrando === item.id" small />
                  <feather-icon v-else icon="TrashIcon" size="18" />
                </b-button>
              </div>
            </div>
          </b-col>
        </b-row>

        <b-row class="mt-1">
          <b-col sm="12">
            <h6 class="p-1" style="text-align: justify;">
              Recuerda que tus fórmulas médicas deben estar vigentes al momento
              de la entrega.
            </h6>
          </b-col>
        </b-row>
      </b-card>
    </validation-observer>
  </div>
</template>
<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapState, mapActions, mapMutations } from "@/store/deliveries";
import vSelect from "vue-select";
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BFormInput
} from "bootstrap-vue";

export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BFormInput,
    ValidationObserver,
    ValidationProvider,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      items: [],
      storeUrl: process.env.VUE_APP_API_URL + '/file-temp/store',
      optionFiles: [
        { id: 'order', title: 'Orden médica' },
        { id: 'license', title: 'Autorización' },
      ],
      // Antes habia dos columnas con la misma clave 'name' y encabezados
      // distintos, asi que el mismo archivo salia repetido.
      fields: [
        { key: 'preview', label: '' },
        { key: 'type', label: 'Tipo' },
        { key: 'name', label: 'Archivo' },
        { key: 'actions', label: '' },
      ],
      // Indicadores de progreso: sin esto el usuario elegia la foto y la
      // pantalla se quedaba muda varios segundos.
      subiendo: {
        order: false,
        license: false,
      },
      borrando: null,
      fileForm: {
        type: null,
        file: null,
        fileLicense: null
      }
    };
  },
  watch: {

  },
  computed: {
    ...mapState(["medicalAuthorizations"]),

    hasOrder() {
      return this.medicalAuthorizations.some((item) => item.type === 'order');
    },

    hasLicense() {
      return this.medicalAuthorizations.some((item) => item.type === 'license');
    },

    conteoOrdenes() {
      return this.medicalAuthorizations.filter((item) => item.type === 'order').length;
    },
  },
  methods: {
    ...mapMutations(["setMedicalAuthorizations"]),
    ...mapActions(["updateMedicalAuthorizations"]),

    async validate() {

      let isValid = await false;

      this.setMedicalAuthorizations(this.medicalAuthorizations);

      //this.$store.dispatch('medicalAuthorizations', this.medicalAuthorizations);

      this.medicalAuthorizations.forEach(authorization => {
        if (authorization.type === 'order') {
          isValid = true;
        }
      });

      if (isValid) {
        return await true;
      } else {
        this.$refs.form.validate();
        
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: `Error`,
            icon: 'CoffeeIcon',
            variant: 'danger',
            text: `Debes cargar al menos una fórmula médica`,
          },
        })
        return await false;
      }
    },

    fileSave(type) {
      this.$refs.form.validate().then(success => {
        if (success) {
          const esOrden = type == 1;
          const archivo = esOrden ? this.fileForm.file : this.fileForm.fileLicense;

          if (!archivo) return;

          // Se envia solo el archivo que corresponde. Antes se mandaban los
          // dos campos siempre y el backend se quedaba con el ultimo, asi
          // que se guardaba el archivo equivocado.
          const clave = esOrden ? 'order' : 'license';
          this.subiendo[clave] = true;

          let formData = new FormData();
          formData.append(esOrden ? 'file' : 'fileLicense', archivo);
          formData.append('type', clave);
          this.$http.post(
            '/file-temp/store',
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
          )
            .then((response) => {
              this.medicalAuthorizations.push(
                response.data.file
              );
              this.resetForm()
              this.$refs.form.reset()
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: `¡Listo!`,
                  icon: 'CheckCircleIcon',
                  variant: 'success',
                  text: esOrden
                    ? `Fórmula médica cargada correctamente`
                    : `Autorización cargada correctamente`,
                },
              })
            })
            .catch(error => {
              // Se muestra el motivo real (tamaño, formato) en vez de un
              // mensaje generico que no le dice nada al usuario.
              const respuesta = error?.response?.data;
              const detalle = respuesta?.errors
                ? Object.values(respuesta.errors).flat()[0]
                : respuesta?.message;

              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: `Error`,
                  icon: 'CoffeeIcon',
                  variant: 'danger',
                  text: detalle || `No se pudo cargar el documento`,
                },
              })
            })
            .finally(() => {
              // Se libera pase lo que pase: si fallara, el campo quedaria
              // bloqueado para siempre.
              this.subiendo[clave] = false;
            })
        }
      })
    },

    async fileDelete(item) {
      // Borrar la formula de un solo toque, sin confirmar, es facil de hacer
      // por accidente y obliga a volver a fotografiarla.
      const confirmado = await this.$bvModal.msgBoxConfirm(
        `¿Seguro que quieres quitar "${item.name}"?`,
        {
          title: 'Quitar documento',
          okVariant: 'danger',
          okTitle: 'Sí, quitar',
          cancelTitle: 'Cancelar',
          centered: true,
        }
      );

      if (!confirmado) return;

      this.borrando = item.id;

      this.$http.post('file-temp/delete/' + item.id).then(response => {
        const deleteItem = this.medicalAuthorizations.findIndex(object => object.id === item.id);
        if (deleteItem !== -1) {
          this.medicalAuthorizations.splice(deleteItem, 1);
        }
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: `Documento eliminado`,
            icon: 'CheckCircleIcon',
            variant: 'success',
            text: `El archivo fue eliminado con éxito`,
          },
        })
      })
        .catch(error => {
          console.log('error')
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: `Error`,
              icon: 'CoffeeIcon',
              variant: 'danger',
              text: `No se pudo eliminar el documento`,
            },
          })
        })
        .finally(() => {
          this.borrando = null;
        })
    },

    esImagen(nombre) {
      return /\.(jpe?g|png|webp|heic|gif)$/i.test(nombre || '');
    },

    // El backend guarda 'public/filetemps/x'; publicamente se sirve en
    // '/storage/filetemps/x' gracias al enlace simbolico de Laravel.
    urlArchivo(item) {
      const base = (process.env.VUE_APP_API_URL || '').replace(/\/api\/?$/, '');
      const ruta = (item.path || '').replace(/^public\//, '');

      return `${base}/storage/${ruta}`;
    },

    // Si la miniatura no carga se oculta en vez de dejar el icono roto.
    ocultar(event) {
      event.target.style.display = 'none';
    },

    getTypeFile(data) {
      const type = data.item.type === 'order' ? 'Fórmula médica' : data.item.type === 'license' ? 'Autorización' : '';
      return type;
    },

    resetForm() {
      // fileLicense tambien se limpia: antes quedaba con el archivo anterior
      // y se reenviaba en la siguiente subida.
      this.fileForm = {
        type: null,
        file: null,
        fileLicense: null
      }
    },

  },
};
</script>

<style>
.form-row {
  border: 1px solid #d8d6de;
  border-radius: 0.357rem;
  padding: 10px;
}

.width-100 {
  width: 100% !important;
}
</style>